"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPressedKey = void 0;
var constants_1 = require("./constants");
var setPressedKey = function (keyCode, isDown) { return ({ type: constants_1.SET_PRESSED_KEY, isDown: isDown, keyCode: keyCode }); };
exports.setPressedKey = setPressedKey;
